//This is auto-generated file from scripts/process-icons.js

import { ArrayElementType } from '../types/utils/ArrayElementType';

export const supportedIconNames = [
  '4g',
  '5g',
  'add',
  'address-book',
  'ai-robot',
  'airplay',
  'alarm-off',
  'alarm',
  'alert-filled',
  'alert',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-subdirectory',
  'arrow-up',
  'attachment',
  'b2b-customer',
  'bag',
  'bar-chart',
  'basketball',
  'battery',
  'blood-pressure',
  'broadband',
  'broken-phone',
  'bulb',
  'business-continuity',
  'business-intelligence',
  'calendar',
  'camera',
  'card-view',
  'care',
  'cart',
  'cast',
  'chat-robot',
  'chat',
  'check-circle-filled',
  'check-circle',
  'checkmark',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'child-1',
  'child-2',
  'close-circle',
  'close',
  'cloud',
  'coffee',
  'connected-building',
  'connected',
  'conversation',
  'copy',
  'core-router',
  'credit-card',
  'customer-dialogue',
  'daas-device',
  'data-transfer',
  'delete',
  'delivery',
  'desktop',
  'devices',
  'dislike',
  'doc',
  'document-doc',
  'document-edit',
  'document-pdf',
  'document-ppt',
  'dot',
  'download',
  'dsl-hub',
  'edit',
  'education',
  'efficiency',
  'email',
  'end-user',
  'entertainment',
  'environment',
  'error-filled',
  'error',
  'esim-simcard',
  'euro',
  'excel',
  'external',
  'face-id',
  'facebook',
  'fiber',
  'film',
  'filter',
  'fingerprint',
  'focus',
  'folder-copy',
  'folder-new',
  'folder',
  'food',
  'fraud',
  'games',
  'getting-started',
  'gif',
  'graph',
  'grid-view',
  'handshake',
  'headphones',
  'heart-filled',
  'heart',
  'help',
  'helppi',
  'home-care',
  'home-installation',
  'home',
  'image',
  'industry',
  'infinite',
  'info-filled',
  'info',
  'instagram',
  'internet',
  'invoice',
  'job-search',
  'kontantkort',
  'laptop',
  'late-payment',
  'letter',
  'like',
  'link',
  'linkedin',
  'list-view',
  'lock-closed',
  'lock-open',
  'login',
  'logout',
  'map',
  'media-content',
  'megaphone',
  'menu',
  'microphone',
  'minus',
  'mms',
  'moisture',
  'money-back',
  'money-euro',
  'money-krone',
  'more-horizontal',
  'more-vertical',
  'music',
  'mute',
  'network',
  'new-contact',
  'new-group',
  'news',
  'offering',
  'offshore',
  'optimization',
  'org-chart',
  'parental-guide',
  'password-invisible',
  'password-visible',
  'pay-monthly',
  'pay-once',
  'payment-success',
  'pebble',
  'people-hub',
  'people',
  'phone-recycling',
  'phone-ringing',
  'phone',
  'pie-chart',
  'plane',
  'play',
  'player-settings',
  'plus-minus',
  'plus',
  'police',
  'portal',
  'premises-datacenter',
  'premises-large',
  'premises-medium',
  'premises-small',
  'premises',
  'present',
  'press-button',
  'price',
  'print',
  'pulse',
  'question-filled',
  'question',
  'rack',
  'record',
  'recycle',
  'refill-card',
  'register',
  'remote-control',
  'repair',
  'report',
  'reservation',
  'reverse',
  'roaming',
  'router',
  'satellite',
  'save',
  'savings',
  'search',
  'secure-device',
  'secured-1',
  'secured-2',
  'send',
  'sense-car',
  'server',
  'service-device',
  'service-supervision',
  'services',
  'settings',
  'share',
  'shopping',
  'shuffle',
  'signature',
  'simcard',
  'skip-back-10sec',
  'skip-back-30sec',
  'skip-forward-10sec',
  'skip-forward-30sec',
  'slow-wifi',
  'smart-wifi',
  'smartphone',
  'smartwatch',
  'smiley-happy',
  'smiley-sad',
  'sms',
  'snapchat',
  'snowflake',
  'sorter',
  'speedometer',
  'spell-check',
  'star-filled',
  'star',
  'stop',
  'store',
  'stream',
  'suitcase',
  'summary',
  'support',
  'sustainability',
  'switch',
  'sync',
  'table-view',
  'tablet',
  'tag',
  'time',
  'trade-phone',
  'trailer',
  'transfer',
  'tv-next',
  'tv-pause',
  'tv-play',
  'tv-previous',
  'tv',
  'twitter',
  'undo',
  'upload',
  'usb',
  'user-admin',
  'vcard',
  'video-conference',
  'video',
  'voice-switch',
  'voicemail',
  'volume',
  'wallet',
  'wallplug',
  'warning',
  'weather',
  'wireless-off',
  'wireless',
  'world-alert',
  'world-off',
  'world-question',
  'world',
  'youtube',
  'zoom',
] as const;

export type SupportedIconName = ArrayElementType<typeof supportedIconNames>;
export default supportedIconNames;
